import * as UI from "@iyk/ui"

import { Checkbox, type CheckboxProps } from "./Checkbox.tsx"

export type CheckboxFieldProps = CheckboxProps & {
  name: string
  id: string
  children: React.ReactNode
  validationMessage?: string
  required?: boolean
  size?: "sm" | "xs"
}

export const CheckboxField = ({
  children,
  name,
  validationMessage,
  required,
  id,
  disabled,
  size,
  ...props
}: CheckboxFieldProps) => {
  return (
    <UI.Field name={name} validationMessage={validationMessage} required={required}>
      <span className={classForField({ size })}>
        <span className="flex h-[1lh] shrink-0 items-center">
          <Checkbox disabled={disabled} id={id} name={name} {...props} />
        </span>
        <label data-disabled={disabled} htmlFor={id} className="data-[disabled]:text-gray-8 select-none">
          {children}
        </label>
      </span>

      <UI.Validity />
    </UI.Field>
  )
}

const classForField = UI.cva(["flex flex-row items-start gap-2"], {
  variants: {
    size: {
      sm: "text-sm",
      xs: "text-xs"
    }
  },
  defaultVariants: {
    size: "sm"
  }
})
